export default __webpack_public_path__ + "static/media/PayAcc.f0cfe48d.png";